import { Autocomplete, Box, createTheme, FormControl, FormHelperText, Stack, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import InfoIcon from '@mui/icons-material/Info';
import ClearIcon from '@mui/icons-material/Clear';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { INPUT_TYPOGRAPHY_SX } from './inputTypography';
const MANDATORY_ASTERISK_COLOR = '#F00214';
import DropdownChevronIcon from '../icons/DropdownChevronIcon';
const AutoCompleteDD = ({ options, valueKey, displayKey, label, disabled, handleChange, handleOpen, selectedValue, name, placeholder, errorMessage, isMandatoryField, handleBlur, hasToolTip, toolTipInfo, autoFocus, showClearIcon, sx, className, PopperComponent, disablePortal, infoIcon, isOcrPrefilled, forceErrorBorder, disabledReason, endAdornment }) => {
    const [t] = useTranslation('global');
    const focusRef = useRef(null);
    const [isFocused, setIsFocused] = React.useState(false);
    const showErrorBorder = Boolean(errorMessage) || Boolean(forceErrorBorder);
    const placeholderText = (placeholder || label || t('Select'));
    const selectedOption = selectedValue;
    const hasSelectedValue = Boolean(selectedOption &&
        ((typeof selectedOption === 'object' && selectedOption[valueKey]) || typeof selectedOption === 'string'));
    const showMandatoryOverlay = Boolean(isMandatoryField) && !hasSelectedValue && !isFocused;
    const theme = createTheme();
    useEffect(() => {
        if (autoFocus && focusRef.current) {
            focusRef.current.focus();
        }
        return () => {
            focusRef.current = null;
        };
    }, [autoFocus]);
    const cstTextStyles = {};
    const stackNode = (React.createElement(Stack, { className: disabled ? 'custom-select-container' : 'custom-select-container' },
        React.createElement(FormControl, { error: showErrorBorder, sx: { position: 'relative' } },
            React.createElement(Box, { component: 'span', display: 'flex', alignItems: 'center' }, infoIcon && infoIcon),
            hasToolTip &&
                React.createElement(Tooltip, { title: toolTipInfo },
                    React.createElement(InfoIcon, { sx: { position: 'absolute', zIndex: 9, right: '39px', top: '29px', color: '#0000008a' }, className: 'cstInfoIcon' })),
            React.createElement(Autocomplete, { disablePortal: disablePortal !== null && disablePortal !== void 0 ? disablePortal : true, id: "common-auto-complete", options: options, getOptionLabel: (option) => t(option[displayKey]), sx: Object.assign(Object.assign({}, cstTextStyles), { width: '100%', backgroundColor: '#fff', borderRadius: '4px', '& .MuiInputBase-root.Mui-disabled': {
                        '& .MuiOutlinedInput-notchedOutline': {
                            background: 'rgb(0 0 0 / 5%)',
                        },
                    } }), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { label: isOcrPrefilled ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 3 } },
                        React.createElement(CheckCircleIcon, { style: { fontSize: 15, color: '#2E7D32' } }),
                        label,
                        isMandatoryField && React.createElement("span", { style: { color: "#F00214" } }, " *"))) : isMandatoryField && label ? (React.createElement(React.Fragment, null,
                        label,
                        React.createElement("span", { style: { color: "#F00214" } }, " *"))) : (label), placeholder: !hasSelectedValue ? placeholderText : '', error: showErrorBorder, InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: endAdornment ? (React.createElement(React.Fragment, null,
                            endAdornment,
                            params.InputProps.endAdornment)) : params.InputProps.endAdornment }), InputLabelProps: Object.assign(Object.assign({}, params.InputLabelProps), { sx: {
                            '&:not(.MuiInputLabel-shrink)': {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: 'calc(100% - 48px)',
                            },
                            '&.MuiInputLabel-shrink': {},
                            '&.Mui-focused': {
                                color: 'inherit',
                            },
                            '& .MuiInputBase-root.Mui-disabled': {
                                '& .MuiOutlinedInput-notchedOutline': {
                                    background: 'rgb(0 0 0 / 4%)',
                                },
                            },
                        } }), sx: Object.assign({}, INPUT_TYPOGRAPHY_SX) }))), disabled: disabled, renderOption: (props, option) => (React.createElement("li", Object.assign({}, props, { key: option[valueKey] }), t(option[displayKey]))), popupIcon: React.createElement(DropdownChevronIcon, null), onChange: (event, valueObj, reason, details) => {
                    event = { target: { value: (showClearIcon && reason == 'clear') || !valueObj ? '' : valueObj[valueKey], name: name } };
                    handleChange(event, valueObj, reason, details);
                }, noOptionsText: React.createElement(Typography, { fontSize: '14px', color: '#696F88' }, t('No Options')), value: selectedValue ? selectedValue : { [displayKey]: '', [valueKey]: '' }, size: "small", limitTags: 5, onBlur: (event) => {
                    setIsFocused(false);
                    const resolvedValue = selectedValue && typeof selectedValue === 'object'
                        ? selectedValue[valueKey]
                        : selectedValue;
                    event = { target: { value: resolvedValue !== null && resolvedValue !== void 0 ? resolvedValue : '', name: name } };
                    handleBlur(event);
                }, onFocus: () => setIsFocused(true), onOpen: (event) => handleOpen && handleOpen(event), clearIcon: showClearIcon &&
                    React.createElement(ClearIcon, null), disableClearable: !showClearIcon, autoFocus: autoFocus, PopperComponent: PopperComponent, componentsProps: {
                    popper: {
                        sx: { zIndex: 1600 }
                    },
                    paper: {
                        sx: { '& li': { color: '#696F88' } }
                    }
                } }),
            React.createElement(FormHelperText, null, errorMessage))));
    return disabled && disabledReason ? (React.createElement(Tooltip, { title: disabledReason, arrow: true, placement: "top" }, stackNode)) : stackNode;
};
export default AutoCompleteDD;
